import { defineComponent as _defineComponent } from 'vue'
import { getjoblist ,getDetailForaccidCompany} from "@/api";
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  watch,
} from "../../../adapter-vue";
import TUIChatEngine, {
  IConversationModel,
  TUIStore,
  StoreName,
  SendMessageOptions,
  TUIChatService,
  SendMessageParams,
} from "@tencentcloud/chat-uikit-engine";
import TUICore, { ExtensionInfo, TUIConstants } from "@tencentcloud/tui-core";
import EmojiPicker from "./emoji-picker/index.vue";
import ImageUpload from "./image-upload/index.vue";
import FileUpload from "./file-upload/index.vue";
import VideoUpload from "./video-upload/index.vue";
import Evaluate from "./evaluate/index.vue";
import Words from "./words/index.vue";
import ToolbarItemContainer from "./toolbar-item-container/index.vue";
import UserSelector from "./user-selector/index.vue";
import { isPC, isH5, isUniFrameWork } from "../../../utils/env";
import TUIChatConfig from "../config";
import { enableSampleTaskStatus } from "../../../utils/enableSampleTaskStatus";
import { ToolbarDisplayType } from "../../../interface";
import Dialog from "../../common/Dialog/index.vue";
import { isEnabledMessageReadReceiptGlobal } from "../utils/utils";
import OfflinePushInfoManager, {
  IOfflinePushInfoCreateParams,
} from "../offlinePushInfoManager/index";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import InterView from "@/components/xypComponents/interView.vue";
interface IProps {
  displayType: ToolbarDisplayType;
}
interface IEmits {
  (e: "scrollToLatestMessage"): void;
  (e: "changeToolbarDisplayType", type: ToolbarDisplayType): void;
  (e: "insertEmoji", emoji: any): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    displayType: { default: "none" }
  },
  emits: ["scrollToLatestMessage", "changeToolbarDisplayType", "insertEmoji"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: "scrollToLatestMessage"): void;
  (e: "changeToolbarDisplayType", type: ToolbarDisplayType): void;
  (e: "insertEmoji", emoji: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { displayType: ToolbarDisplayType }




const h5Dialog = ref<HTMLElement>();
const currentConversation = ref<IConversationModel>();
const isGroup = ref<boolean>(false);
const selectorShowType = ref<string>("");
const userSelectorRef = ref();
const emojiPickerRef = ref<InstanceType<typeof EmojiPicker>>();
const currentUserSelectorExtension = ref<ExtensionInfo>();
const currentExtensionList = ref<ExtensionInfo[]>([]);
const featureConfig = TUIChatConfig.getFeatureConfig();
const isRenderedEmojiPicker = ref<boolean>(true);
const outDialogShow = ref<boolean>(false);
const interViewRef = ref();
// 从 URL 参数获取 jobName
const search = window.location.search;
const params = new URLSearchParams(search);
const jn = ref(params.get("jobName"));
const job_id = ref<string | number>("");
isRenderedEmojiPicker.value =
  featureConfig.InputEmoji || featureConfig.InputStickers;
const joblist = ref<any>([]);
const jobobj = ref<any>({});
onMounted(() => {
  TUIStore.watch(StoreName.CUSTOM, {
    activeConversation: onActiveConversationUpdate,
  });
  // 监听消息列表更新，获取 job_id
  TUIStore.watch(StoreName.CHAT, {
    messageList: onMessageListUpdated,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CUSTOM, {
    activeConversation: onActiveConversationUpdate,
  });
  TUIStore.unwatch(StoreName.CHAT, {
    messageList: onMessageListUpdated,
  });
});

watch(
  () => props.displayType,
  (newValue) => {
    if (newValue === "none") {
      emojiPickerRef.value?.closeEmojiPicker();
    } else {
      emits("scrollToLatestMessage");
    }
  }
);

const onActiveConversationUpdate = (conversationID: string) => {
  if (!conversationID) {
    return;
  }
  if (conversationID !== currentConversation.value?.conversationID) {
    getExtensionList();
    currentConversation.value = TUIStore.getData(
      StoreName.CONV,
      "currentConversation"
    );
    isGroup.value = conversationID.startsWith(TUIChatEngine.TYPES.CONV_GROUP);
  }
};

const onMessageListUpdated = (list: any[]) => {
  // 获取消息列表中的扩展信息，提取 job_id 和 jobName
  const l = list.filter((i) => i.isSupportExtension && i.status === "success");
  if (l.length > 0) {
    TUIChatService.getMessageExtensions(l[l.length - 1]).then(
      (extensions: any) => {
        const jobNameExt = extensions.data.extensions.find(
          (i) => i.key == "jobName"
        );
        const jobIdExt = extensions.data.extensions.find(
          (i) => i.key == "job_id"
        );
        if (jobNameExt && jobNameExt.value && !jn.value) {
          jn.value = jobNameExt.value;
        }
        if (jobIdExt) {
          job_id.value = jobIdExt.value;
        }
      }
    );
  }
};

const getExtensionList = () => {
  const chatType = TUIChatConfig.getChatType();
  const params: Record<string, boolean | string> = { chatType };
  // Backward compatibility: When callkit does not have chatType judgment, use filterVoice and filterVideo to filter
  if (chatType === TUIConstants.TUIChat.TYPE.CUSTOMER_SERVICE) {
    params.filterVoice = true;
    params.filterVideo = true;
    enableSampleTaskStatus("customerService");
  }
  currentExtensionList.value = [
    ...TUICore.getExtensionList(
      TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID,
      params
    ),
  ].filter((extension: ExtensionInfo) => {
    if (extension?.data?.name === "search") {
      return featureConfig.MessageSearch;
    }
    return true;
  });
};

const extensionListShowInStart = computed<ExtensionInfo[]>(() => {
  if (isPC) {
    const extensionList = currentExtensionList.value.filter(
      (extension: ExtensionInfo) => extension?.data?.name !== "search"
    );
    return extensionList;
  }
  return currentExtensionList.value;
});

const extensionListShowInEnd = computed<ExtensionInfo[]>(() => {
  if (isPC) {
    const searchExtension = currentExtensionList.value.find(
      (extension) => extension?.data?.name === "search"
    );
    return searchExtension ? [searchExtension] : [];
  }
  return [];
});

// handle extensions onclick
const onExtensionClick = (extension: ExtensionInfo) => {
  switch (extension?.data?.name) {
    case "voiceCall":
      onCallExtensionClicked(extension, 1);
      break;
    case "videoCall":
      onCallExtensionClicked(extension, 2);
      break;
    default:
      (extension as any)?.listener?.onClicked(
        currentConversation.value?._conversation
      );
      break;
  }
};

const onCallExtensionClicked = (extension: ExtensionInfo, callType: number) => {
  selectorShowType.value = extension?.data?.name;
  if (currentConversation?.value?.type === TUIChatEngine.TYPES.CONV_C2C) {
    extension.listener?.onClicked?.({
      userIDList: [currentConversation?.value?.conversationID?.slice(3)],
      type: callType,
    });
  } else if (isGroup.value) {
    currentUserSelectorExtension.value = extension;
    userSelectorRef?.value?.toggleShow &&
      userSelectorRef.value.toggleShow(true);
  }
};

const genExtensionIcon = (extension: any) => {
  return extension?.icon;
};

const genExtensionText = (extension: any) => {
  return extension?.text;
};

const onUserSelectorSubmit = (selectedInfo: any) => {
  currentUserSelectorExtension.value?.listener?.onClicked?.(selectedInfo);
  currentUserSelectorExtension.value = undefined;
};

const onUserSelectorCancel = () => {
  currentUserSelectorExtension.value = undefined;
};

const insertEmoji = (emojiObj: object) => {
  emits("insertEmoji", emojiObj);
};

const dialogShowInH5 = (dialogDom: any) => {
  if (!isH5) {
    return;
  }
  h5Dialog.value?.appendChild && h5Dialog.value?.appendChild(dialogDom);
};

const dialogCloseInH5 = (dialogDom: any) => {
  if (!isH5) {
    return;
  }
  if (dialogDom) {
    h5Dialog.value?.removeChild && h5Dialog.value?.removeChild(dialogDom);
  }
};
function closeoutDialogShow() {
  getjoblist({ status: 1, page: 1, count: 100 }).then((res) => {
    joblist.value = res.data.list.filter(item => !(item.type == 3 && item.part_time_type == 2));
  });

  outDialogShow.value = true;
}
const inviteInterview = async () => {
  // process  简历进度 1:已投递 2:已查看 3:邀面试中 4:不合适 5:面试通过 6:面试不通过 7:已下载
  let params = {
    accid: currentConversation?.value?.conversationID?.slice(3),
    job_id: job_id.value != "no" ? job_id.value : 0,
  };
  const res = await getDetailForaccidCompany(params);
  if(res.code == 1 && (res.data.process == 1 || res.data.process == 7)){
    let id = res.data.id;
    interViewRef.value?.toggle(true);
    interViewRef.value?.getdetails({id:id,job_id: job_id.value,is_honesty:res.data.is_honesty});
  }else {
    let process = res.data.process;
    let str = '';
    if(process < 1){
      str = '对方还未投递简历'
    }
    if(process >= 2){
      str = '已经邀请过面试了'
    }
    Toast({
      message: str,
      type: TOAST_TYPE.ERROR,
    });
  }
}
const handleSelect = (item) => {
  item.check = !item.check;
  jobobj.value = item;
};
const handclose = () => {
  jobobj.value = {};
  outDialogShow.value = false;
};
const handleManage = (res) => {
  console.log(res);
  if (!jobobj.value.id)
    return Toast({
      message: "请先选择一个职位",
      type: TOAST_TYPE.ERROR,
    });
  if(res.type == 3 && res.part_time_type == 2) {
    return Toast({
      message: "代招兼职无法邀请投递",
      type: TOAST_TYPE.ERROR,
    });
  }
  outDialogShow.value = false;
  let info = JSON.parse(localStorage.getItem("info"));
  let str = `${info.scale_name ? info.scale_name + " | " : ""}${
    info.category_name ? info.category_name.replace(/\r/gi, "") + " | " : ""
  }${info.nature_name}`;
  // scale + ' | ' + company_category + ' | ' + nature;

  if (str.length > 10) {
    str.substring(1, 15) + "...";
  }
  let salary_str = res.salary_type ? res.salary + "元/" + { 1: "小时", 2: "日", 3: "月", }[res.salary_type]:res.salary + "元";
  let obj = {
    businessID:'job_info_yaoqing',
    jobInfo:`${ res.city_name ? res.city_name+'|':'' } ${ res.area_name ? res.area_name+'|':'' } ${res.education_name}`,
    comanyName:localStorage.getItem("name"),
    jobName:res.title,
    job_id:res.id,
    salary: salary_str,
    time: res.create_time,
    companyInfo: str,
    image: info.avatar_str,
    job_type: "0",
    accid: localStorage.getItem("tencent_accid"),
    settlement_type: res.part_settlement_type ? { 1: "日结", 2: "周结", 3: "月结", 4: "项目结" }[res.part_settlement_type]:'',
    version: 4,
    extension: 1,
  }
  const payload = {
    // data: `{"businessID":"job_info_yaoqing","jobInfo":"${
    //   res.city_name ? res.city_name + " | " : ""
    // }${res.area_name ? res.area_name + " | " : ""}${
    //   res.education_name
    // }","comanyName":"${localStorage.getItem("name")}","jobName":"${
    //   res.title
    // }","job_id":"${res.id}","salary":"${res.salary}","time":"${
    //   res.create_time
    // }","companyInfo":"${str}","image":"${
    //   info.avatar_str
    // }","job_type":"${0}","accid":"${localStorage.getItem(
    //   "tencent_accid"
    // )}","version":4,"extension":1}`,
    data:JSON.stringify(obj),
    description: "1",
    extension: "1",
  };
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID ||
      currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload,
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  };
  jobobj.value = {};
  const offlinePushInfoCreateParams: IOfflinePushInfoCreateParams = {
    conversation: currentConversation.value,
    payload: options.payload,
    messageType: TUIChatEngine.TYPES.MSG_CUSTOM,
  };
  const sendMessageOptions: SendMessageOptions = {
    offlinePushInfo: OfflinePushInfoManager.create(offlinePushInfoCreateParams),
  };
  TUIChatService.sendCustomMessage(
    options as SendMessageParams,
    sendMessageOptions
  );
};
expose({
  closeoutDialogShow,
});
const onInterViewUpdate = (row) => {
  // 面试邀请更新回调
  let info = {
    id:row.id, //投递记录的id
    is_honesty:row.is_honesty,
    businessID:'job_info_yaoqing',
    extension: "3",
  };
  const payload = {
    data:JSON.stringify(info),
  }
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID ||
      currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload,
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  };
  const offlinePushInfoCreateParams: IOfflinePushInfoCreateParams = {
    conversation: currentConversation.value,
    payload: options.payload,
    messageType: TUIChatEngine.TYPES.MSG_CUSTOM,
  };
  const sendMessageOptions: SendMessageOptions = {
    offlinePushInfo: OfflinePushInfoManager.create(offlinePushInfoCreateParams),
  };
  TUIChatService.sendCustomMessage(
    options as SendMessageParams,
    sendMessageOptions
  );
};

return { __sfc: true,props, emits, h5Dialog, currentConversation, isGroup, selectorShowType, userSelectorRef, emojiPickerRef, currentUserSelectorExtension, currentExtensionList, featureConfig, isRenderedEmojiPicker, outDialogShow, interViewRef, search, params, jn, job_id, joblist, jobobj, onActiveConversationUpdate, onMessageListUpdated, getExtensionList, extensionListShowInStart, extensionListShowInEnd, onExtensionClick, onCallExtensionClicked, genExtensionIcon, genExtensionText, onUserSelectorSubmit, onUserSelectorCancel, insertEmoji, dialogShowInH5, dialogCloseInH5, closeoutDialogShow, inviteInterview, handleSelect, handclose, handleManage, onInterViewUpdate, EmojiPicker, ImageUpload, FileUpload, VideoUpload, Words, ToolbarItemContainer, UserSelector, isPC, isH5, isUniFrameWork, Dialog, InterView }
}

})